// extracted by mini-css-extract-plugin
module.exports = {"base-info__editor":"TopPageCustomIntroduction_base-info__editor__p_ExX"};